export const input = {
  identifier: 'Identifiant',
  password: 'Mot de passe',
  message: 'Identifiant ou mot de passe incorrect',
};
